import { composeIO } from 'react-compose-io'
import { collapseInadimplenciaItemIO } from './CollapseInadimplenciaItem.IO'
import { CollapseInadimplenciaItemView } from './CollapseInadimplenciaItem.View'

export const CollapseInadimplenciaItem = composeIO(CollapseInadimplenciaItemView, collapseInadimplenciaItemIO)
